<template>
	<div class="flex flex-col">
    	<div class="text-grey-darker text-2xl">
          {{this.title}}    
    	</div>
    	
      <div class="my-2 text-grey text-bold text-md">
        {{this.subtitle}}
    	</div>
      
      <albums class="mt-4"/>
  </div>
</template>

<script>
import Albums from "./Albums";
import Album from "./Album";

export default {
  components: {
    Album,
    Albums,
  },
  name: "Gallery",
  data() {
    return {
      welcomeMessage: "",
      createAlbumButtonText: "New Album",
      isCreateAlbumModalVisible: false,
      title: "At a glance",
      subtitle: "Show important dynamic data",
    };
  },

  created() {
    // Listen for events
  },

  methods: {
    showCreateAlbum() {
      this.isCreateAlbumModalVisible = true;
    },

    closeCreateAlbumModal() {
      this.isCreateAlbumModalVisible = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Gallery.vue